import React, { useState, useEffect } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import apf_logo from '../../../images/auth/APF-Big-Logo.png';
import apf_small_logo from '../../../images/auth/APF-Small-Logo.png';

export function  NavMenuToggle(){
	setTimeout(()=>{	
		let mainwrapper = document.querySelector("#main-wrapper");
		if(mainwrapper.classList.contains('menu-toggle')){
			mainwrapper.classList.remove("menu-toggle");
		}else{
			mainwrapper.classList.add("menu-toggle");
		}
	},200);
}

export function NavMenuTogglespecific(shouldShrink) {
  const mainwrapper = document.querySelector("#main-wrapper");
  if (!mainwrapper) return;
  mainwrapper.classList.toggle("menu-toggle", shouldShrink);
}


const NavHader = () => {
  const location = useLocation();
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const shouldShrink = location.pathname.startsWith("/lead-to-subscription") || location.pathname.startsWith("/new-subscriptions");
    setToggle(shouldShrink);
    NavMenuTogglespecific(shouldShrink);
  }, [location.pathname]);

  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo justify-content-start p-0 ms-1">
        <img src={apf_logo} alt="Logo" className="brand-title w-250px h-70px mw-unset ms-0" />
        <img src={apf_small_logo} alt="Small Logo" className="logo-abbr w-50px w-lg-65px mw-unset ms-2 h-lg-45px h-40px" />
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          //openMenuToggle();
         NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
